export default __webpack_public_path__ + "static/community-events-section_hero-desktop-e0ad59b2a396fcefbcb85c91690a47cf.jpg";